/**
 * @mixin
 */
import uniqueId from '@/utils/uniqueId';
import { isUndefinedOrNullOrEmpty } from '@/utils/inspect';
import featureSwitchMixin from '@/mixins/visibility-based-on-feature-switch-mixin';

export default {
	mixins: [featureSwitchMixin],
	props: {
		/**
		 * Sets the id of the element.
		 * @type {String}
		 */
		id: {
			type: [String],
			default: null
		},
		/**
		 * Disable the entire component.
		 * @type {Boolean}
		 */
		disabled: {
			type: Boolean,
			default: false
		},
		/**
		 * Sets the name of the element.
		 * @type {String}
		 */
		name: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			uid: '',
			uname: ''
		};
	},
	created() {
		this.uid = this.id || uniqueId('dms_');
	},
	mounted() {
		if (isUndefinedOrNullOrEmpty(this.name)) {
			this.uname = this.uid;
		} else {
			this.uname = this.name;
		}
	},
	methods: {
		getUniqueId(prefix) {
			return uniqueId(prefix);
		},
		getById(id) {
			return (
				document.getElementById(/^#/.test(id) ? id.slice(1) : id) ||
				null
			);
		},
		onMouseEnter(e) {
			this.$emit('mouseenter', e);
		},
		onMouseLeave(e) {
			this.$emit('mouseleave', e);
		}
	}
};
